<template>
  <div>
    <Modal
      ref="modal"
      title="Import Agent Roster"
      body="You can import your agent roster from a CSV file."
      action="Start Import"
      actionColor="indigo"
      @closeModal="handleCancel"
      @handleAction="startImport"
    >
      <p class="text-sm text-gray-500 my-4">
        Download our
        <a href="https://app.humaniz.io/agent_roster_template.csv" target="_blank" class="text-indigo-600 font-semibold"
          >agent roster template</a
        >
        CSV, add in your agent roster, and then upload here.
      </p>
      <FileInput
        label="Agent Roster CSV"
        accept=".csv"
        multiple="false"
        :modelValue="file"
        @update:modelValue="file = $event"
      />
    </Modal>
  </div>
</template>

<script>
import Modal from '../shared/Modal.vue';
import FileInput from '../shared/FileInput.vue';

export default {
  components: {
    Modal,
    FileInput,
  },
  data() {
    return {
      file: null,
    };
  },
  methods: {
    async startImport() {
      let formData = new FormData();

      formData.append('agent_roster_import_request[file]', this.file[0], this.file[0].name);

      const res = await fetch(`/api/agent_roster_import_requests`, {
        method: 'POST',
        headers: {
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
        body: formData,
      });

      const { status } = await res.json();

      if (status === 'success') {
        this.handleCancel();
        this.$store.commit('general/showAlert', {
          alertType: 'success',
          alertTitle: 'Task Updated',
          alertDescription: 'Your task was successfully updated.  Use the button below to dismiss this alert.',
        });
      }
    },
    handleCancel() {
      this.$emit('handleMessageTeamCancel');
    },
  },
};
</script>
